import React, { useEffect } from "react";
import goToScreen from "../lib/goToScreen";
import isSiteBuilder from "../lib/isSiteBuilder";
import BackgroundPhoto from "../Components/BackgroundPhoto";

export default function Wait({ history }) {
  document.title = "Onboarding";
  useEffect(() => {
    if (isSiteBuilder()) return;
    window.OrendaGetResponse(
      { event_name: "page load - wait" },
      () => goToScreen(history, "confirm"),
      false
    );
    return;
  }, [history]);

  return (
    <BackgroundPhoto>
      <h5>Please wait while our verification checks finish.</h5>
      <h5>This can take up to 3 minutes.</h5>
    </BackgroundPhoto>
  );
}
